import { AppSettings } from "@layerswap/utils";
export default AppSettings;
